import { AccountTypes, IndividualDesignationListedTypes, YesNoEmpty } from '@interfaces/models';
import { TriageRelationshipType } from '@src/app/secure/account-triage/models/triage-relationship.model';
import { AccountTriageState } from '@store/reducers/account-triage/account-triage.reducer';

import { TriageAccountType, TriageForm } from '../models';

export const isIraAccount = (accountType: TriageAccountType): boolean => {
  const iraAccountTypes = [
    TriageAccountType.TRADITIONAL_IRA,
    TriageAccountType.INHERITED_TRADITIONAL_IRA,
    TriageAccountType.INHERITED_ROTH_IRA,
    TriageAccountType.ROTH_IRA,
  ];

  return iraAccountTypes.includes(accountType);
};

export const isMarriesDecedentNotSpouse = (form: TriageForm) => {
  return (
    isIraAccount(form.accountType) &&
    form.relationshipType === TriageRelationshipType.EXECUTOR &&
    form.isOnlyExecutor === YesNoEmpty.YES &&
    form.wasMarried === YesNoEmpty.YES &&
    form.isDecedentSpouse === YesNoEmpty.NO
  );
};

export const isIndividualExecutor = (accountTriage: AccountTriageState) =>
  accountTriage &&
  accountTriage.accountTypeInheriting === AccountTypes.INDV &&
  accountTriage.individualDesignation === IndividualDesignationListedTypes.EXECUTOR;

export const isIRASingleExecutor = (accountTriage: AccountTriageState) =>
  accountTriage &&
  accountTriage.accountTypeInheriting === AccountTypes.IRA &&
  accountTriage.isOnlyExecutor === YesNoEmpty.YES;
